export const userAuthenticationDataInitialState = {
	isAuthenticated: false,
	token: "",
	exp: "",
};

export const userInitialState = {
	id: 0,
	documento: "",
	nome: "",
	primeiroNome: "",
	email: "",
	celular: "",
	telefoneValidado: false,
	uuid: "",
	dataNascimento: "",
	sexo: "I",
	registrado: false,
	newsletter: false,
	termsOfUse: false,
	termsOfUseVersion: 0,
	cutOffValue: 0,
	customerIdHash: "",
	createdAt: "",
};

export const userACPInitialState = {
	auth: {
		access_token: "",
		refresh_token: "",
		isAuthenticated: false,
	},
	customer: {
		id: 0,
		uuid: "",
		document: "",
		email: "",
		birthdate: "",
		phone: "",
		full_name: "",
		social_name: "",
		experience: "",
		customerIdHash: "",
		created_at: "",
		required_updates: undefined,
		optional_updates: undefined,
		hidden_email: "",
		hidden_phone: "",
		isUnified: false,
		contactStatus: {
			email: {
				unsub: false,
				bounced: false,
				blocked: false,
				neverEngaged: false,
				customer_engagement_status: "",
				expires: 0,
			},
		},
	},
};

export const userACInitialState = {
	auth: {
		access_token: "",
		refresh_token: "",
		isAuthenticated: false,
	},
	user: {
		id: 0,
		documento: "",
		nome: "",
		primeiroNome: "",
		nomeSocial: "",
		admin: false,
		email: "",
		celular: "",
		telefoneValidado: "",
		uuid: "",
		dataNascimento: "",
		sexo: "I",
		registrado: "false",
		newsletter: false,
		termsOfUse: "",
		termsOfUseVersion: 0,
		cutOffValue: "",
		customerIdHash: "",
		createdAt: "",
	},
};

export const userCPInitialState = {
	auth: {
		access_token: "",
		refresh_token: "",
		isAuthenticated: false,
	},
	user: {
		document: "",
		email: "",
		celular: "",
	},
};
